module.exports = __webpack_public_path__ + "img/ck.e5a5c70c.svg";